
import Vue from 'vue';
import { Tags } from '@descomplica/vue-components';
import { ClassroomModel } from '@descomplica/dex-models';
import Card from './Card.vue';
import ProgressBar from '../progress/ProgressBar.vue';
import DisciplineCardSkeleton from '../skeletons/DisciplineCardSkeleton.vue';
import SoonBadge from '../SoonBadge.vue';

type GetRouteToParams = {
  name?: String;
  params?: { [key: string]: string };
};

export default Vue.extend({
  components: {
    Card,
    ProgressBar,
    DisciplineCardSkeleton,
    Tags,
    SoonBadge,
  },
  props: {
    classroom: {
      required: true,
      type: Object as Vue.PropType<ClassroomModel>,
    },
    isLoading: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    hasBoards(): boolean {
      const { boardsClassroomsByClassroomId: boards } = this.classroom;
      return !!boards && !!boards.length;
    },
    isPreregistered(): boolean {
      const { boards } = this.classroom;
      const board = Array.isArray(boards) ? boards[boards.length - 1] : null;
      return board ? board.isPreregistered : false;
    },
    progress(): number {
      const classroomProgress = this.$store.getters.classroomProgressById(this.classroom.id);

      return classroomProgress || 0;
    },
    microcertificates(): string[] {
      return [];
    },
  },
  methods: {
    toggleModal(): void {
      this.$emit('soonModal');
    },
    getRouteToParams(classroom: ClassroomModel): GetRouteToParams {
      if (!classroom.slug) return {};

      if (this.isPreregistered) return {};

      return {
        name: 'classroom',
        params: { classroomSlug: classroom.slug },
      };
    },
  },
});
